<div class="sh-panel">
    <sh-notification *ngIf="(hasHierarchy$ | async) && (isLoading$ | async)" [message]="'ui.loading' | translate"></sh-notification>

    <sh-notification
        *ngIf="!(hasHierarchy$ | async) && !(isLoading$ | async) && !(loadingError$ | async)"
        [type]="notificationType.Update"
        [message]="'hierarchy.empty.no-hierarchy' | translate"
    ></sh-notification>

    <sh-notification
        *ngIf="(loadingError$ | async) && !(isLoading$ | async)"
        [type]="notificationType.Error"
        [message]="'hierarchy.error.failed-to-load' | translate"
        [icon]="'delete'"
    ></sh-notification>

    <section *ngIf="(hasHierarchy$ | async) && !(isLoading$ | async) && !(loadingError$ | async)">
        <h6 class="sh-clear-margin-bottom">{{ "hierarchy.parent" | translate }}</h6>
        <sh-generic-list
            *ngIf="mainHierarchyItem$ | async as main"
            [rowElements]="main"
            [highlightedItem]="currentHierarchyItem$ | async"
            [actionItems]="mainHierarchyItemActions$ | async"
            [availableSelect]="false"
            [columns]="columns"
        ></sh-generic-list>

        <h6>{{ "hierarchy.children" | translate }}</h6>
        <sh-generic-overview
            [columns]="columns"
            [paginatedResults]="paginatedChildHierarchyItems$ | async"
            [highlightedItem]="currentHierarchyItem$ | async"
            [actionItems]="childHierarchyItemsActions$ | async"
            [hasError]="loadingError$ | async"
            [isLoading]="isLoading$ | async"
            [showViewToggle]="false"
            [allowSort]="false"
            [searchBarMode]="searchBarMode"
            [availableSelect]="false"
            [xxResultsLabelKey]="'general.xx-results.item'"
            [noResultsLabelKey]="'general.no-results.item'"
            (paginationInfoChanged)="onChildHierarchyItemsPaginationInfoChanged($event)"
        ></sh-generic-overview>
    </section>
</div>
